(function () {
    "use strict";

    angular.module("app").component("cisAdministratorsView", {
        template: `
            <table class="table">
                <thead>
                    <tr>
                        <th i18n="Cis_Administrator_Type_TableHeader"></th>
                        <th i18n="Cis_Administrator_Identity_TableHeader"></th>
                        <th i18n="Organisation_Organisation"></th>
                        <th i18n="Cis_Administrator_ContactInfo_TableHeader"></th>
                        <th i18n="Cis_Administrator_ClearanceInfo_TableHeader"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="danger" ng-if="$ctrl.administrators.length === 0">
                        <td colspan="4">
                            <strong i18n="CIS_NoAdministratorsSelected"></strong>
                            <br>
                        </td>
                    </tr>
                    <tr ng-repeat="admin in $ctrl.administrators">
                        <td>{{admin.TypeCode | codeValue:'codeCisAdministratorTypes'}}</td>
                        <td>
                            <div ng-if="admin.TypeCode != $ctrl.CisAdministratorTypeCode.ManagedServiceProvider">
                                {{admin.Name}} {{admin.FirstName}}
                                <span class="subtle-sub-text">{{admin.PersonNumber | rrNumber}}</span>
                            </div>
                            <div ng-if="admin.TypeCode == $ctrl.CisAdministratorTypeCode.ManagedServiceProvider">
                                <strong i18n="Label_Not_Applicable"></strong>                            
                            </div>
                        </td>
                        <td>
                            <div ng-if="admin.TypeCode == $ctrl.CisAdministratorTypeCode.InternalAdministrator">
                                <strong i18n="Label_Not_Applicable"></strong>
                            </div>
                            <div ng-if="admin.TypeCode != $ctrl.CisAdministratorTypeCode.InternalAdministrator">
                                {{admin.OrganisationName}}
                                <span class="subtle-sub-text">{{admin.OrganisationNumber | kboNumber}}</span>
                            </div>
                        </td>
                        <td>
                            <i class="fa fa-phone"></i> {{admin.PhoneNumber}}<br>
                            <i class="fa fa-at"></i> {{admin.EmailAddress}}
                        </td>
                        <td style="width: 500px">
                            <div ng-if="$ctrl.detailTemplate" ng-include="$ctrl.detailTemplate"></div>
                            <div ng-if="!$ctrl.detailTemplate">
                                <habil-ivm ng-if="admin.ClearanceInfo" clearance="admin.ClearanceInfo"></habil-ivm>
                                <strong ng-if="!admin.ClearanceInfo" i18n="Shared_NoClearanceFound"></strong>
                            </div>                            
                        </td>
                    </tr>
                </tbody>
            </table>`,
        bindings: { administrators: "<", detailTemplate: "<", },
        controller: cisAdministratorsViewController,
    });

    cisAdministratorsViewController.$inject = ["enumService",];
    function cisAdministratorsViewController({ CisAdministratorTypeCode }) {
        const vm = this;

        vm.CisAdministratorTypeCode = CisAdministratorTypeCode;
    }
})();
